import * as React from "react";
import PageLayout from "../../Components/UI/PageLayout.js";
import ResetButton from "../../Components/Admin/ResetButton.js";

const AdminPage = () => {
  return (
    <PageLayout
      title="Admin"
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Admin" }]}
    >
      <ResetButton />
    </PageLayout>
  );
};

export default AdminPage;
